import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import Button, { BUTTON_STYLE } from '../../../shared-components/Button/Button';
import { redirectFlowAction } from '../../../framework/store/RedirectFlow/RedirectFlowActions';
import { spinnerOpen } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { REDIRECT_SUFFIX, FLOW_TYPE } from '../../../framework/App/AppConstants';
import './CancelUrl.less';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import { handleQualtricsClick, ESCAPE_HATCH_ID } from '../../../shared-utilities/qualtrics';

const LOCALE_PREFIX = 'GB/components/CancelUrl/CancelUrl';

export const COMPONENT_STYLE = {
    ESCAPE_HATCH_BUTTON: 'ESCAPE_HATCH_BUTTON',
    FOOTER_LINK: 'FOOTER_LINK',
    LINK_BUTTON: 'LINK_BUTTON' // Button underneath call to action buttons (continue, apply)
};

export class CancelUrl extends Component {
    static propTypes = {
        doCancelRedirect: PropTypes.func.isRequired,
        fireFptiEvent: PropTypes.func,
        merchantName: PropTypes.string,
        isPayInFullNowAvailable: PropTypes.bool,
        enableEscapeHatch: PropTypes.bool,

        // Passed in props
        componentType: PropTypes.oneOf(Object.values(COMPONENT_STYLE)),
        customOnClick: PropTypes.func, // Custom on click handler which overrides default behavior
        fptiEvent: PropTypes.shape({ // Convenience prop for FPTI tracking
            stateName: PropTypes.string,
            transitionName: PropTypes.string
        }),
        feedbackOnCancel: PropTypes.bool,
        qualtricsInterceptId: PropTypes.string
    };

    static defaultProps = {
        componentType: COMPONENT_STYLE.FOOTER_LINK,
        isPayInFullNowAvailable: false
    };

    handleClick = (event, cancelUri) => {
        const { customOnClick, doCancelRedirect, fireFptiEvent, fptiEvent, enableEscapeHatch, feedbackOnCancel, qualtricsInterceptId } = this.props;


        if (customOnClick) {
            return customOnClick(event);
        }

        if (fptiEvent) {
            fireFptiEvent(fptiEvent.stateName, fptiEvent.transitionName);
        }

        if (enableEscapeHatch) {
            handleQualtricsClick(event, ESCAPE_HATCH_ID, qualtricsInterceptId, () => {
                return doCancelRedirect(cancelUri);
            });
        } else {
            return doCancelRedirect(cancelUri);
        }
    };

    handleClickFooterLink = event => {
        this.handleClick(event, REDIRECT_SUFFIX.CANCEL_REDIRECT);
    };

    handleClickEscapeHatchButton = event => {
        const { isPayInFullNowAvailable } = this.props;
        const cancelUri = isPayInFullNowAvailable ? REDIRECT_SUFFIX.PAY_IN_FULL_REDIRECT : REDIRECT_SUFFIX.CANCEL_REDIRECT;
        this.handleClick(event, cancelUri);
    };

    handleClickLinkButton = event => {
        const { isPayInFullNowAvailable } = this.props;
        const cancelUri = isPayInFullNowAvailable ? REDIRECT_SUFFIX.PAY_IN_FULL_REDIRECT : REDIRECT_SUFFIX.CANCEL_REDIRECT;
        this.handleClick(event, cancelUri);
    };

    render() {
        const { componentType, merchantName } = this.props;
        let cancelComponent;

        switch (componentType) {
            case COMPONENT_STYLE.ESCAPE_HATCH_BUTTON:
                cancelComponent = (
                    <div className="CancelUrl CancelUrl-escape-hatch">
                        <Button
                            data-automation-id="cancel"
                            btnStyle={BUTTON_STYLE.PP_SECONDARY}
                            fullWidth={true}
                            onClick={this.handleClickEscapeHatchButton}
                        >
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.cancelApplicationEscapeHatch`}
                            />
                        </Button>
                    </div>
                );
                break;
            case COMPONENT_STYLE.LINK_BUTTON:
                cancelComponent = (
                    <div className="CancelUrl CancelUrl-link-button">
                        <Button
                            data-automation-id="cancel"
                            btnStyle={BUTTON_STYLE.LINK}
                            onClick={this.handleClickLinkButton}
                        >
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.cancelApplication`}
                            />
                        </Button>
                    </div>
                );
                break;
            case COMPONENT_STYLE.FOOTER_LINK:
            default:
                cancelComponent = (
                    <div className="CancelUrl CancelUrl-footer">
                        <Button
                            data-automation-id="cancel"
                            btnStyle={BUTTON_STYLE.LINK}
                            onClick={this.handleClickFooterLink}
                        >
                            {merchantName ? (
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.cancelApplicationWithMerchant`}
                                    values={{ merchantName }}
                                />
                            ) : (
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.cancelApplication`}
                                />
                            )}
                        </Button>
                    </div>
                );
        }

        return cancelComponent;
    }
}

export const mapStateToProps = state => ({
    merchantName: _.get(state, 'serverData.merchantName'),
    isPayInFullNowAvailable: _.get(state, 'serverData.isPayInFullNowAvailable'),
    enableEscapeHatch: _.get(state, 'serverData.featureFlags.wireOnQualtricCancel'),
    feedbackOnCancel: _.get(state, 'serverData.elmo.feedbackOnCancel', false) === true,
    qualtricsInterceptId: _.get(state, 'serverData.qualtricsInterceptId')
});

export const mapDispatchToProps = dispatch => ({
    doCancelRedirect(actionUri) {
        dispatch(spinnerOpen());
        dispatch(redirectFlowAction(actionUri));
    },
    fireFptiEvent(stateName, transitionName) {
        dispatch(trackTransition(stateName, transitionName));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(CancelUrl);
